
class UrlBuilderInterface{
	getUrl(){};
	buildUrl(){};
	buildUrlPath(){};
	buildApiKeyParam(){};
	buildUrlParams(){};
}

export class UrlBuilder extends UrlBuilderInterface{
	constructor(apiConfig){
		super();
		var _apiConfig = apiConfig || {},
			_endpoint,
			_apiKey,
			_params
		;
		
		
		// ======
		// Public
		// ------
		Object.defineProperty(this,'getApiConfig',{
			value : function(){
				return _apiConfig;
			},
			enumerable : true 
		});
		
		Object.defineProperty(this,'getEndpoint',{
			value: function(){ return _endpoint },
			enumerable: true 
		});	
		Object.defineProperty(this,'setEndpoint',{
			value: function(endpoint){ 
				_endpoint = endpoint;
			},
			enumerable: true 
		});			
		
		Object.defineProperty(this,'setApiKey',{
			value : function(apiKey){
				_apiKey = apiKey
			},
			enumerable : true 
		});
		
		Object.defineProperty(this,'getApiKey',{
			value: function(){ return _apiKey },
			enumerable: true 
		});
		
		Object.defineProperty(this,'setParams',{
			value : function(params){
				_params = params
			},
			enumerable : true 
		});

		Object.defineProperty(this,'getParams',{
			value: function(){ return _params },
			enumerable: true 
		});
	}
	buildUrl(){
		var url, params;
		var path = this.buildUrlPath();
		var key = this.buildApiKeyParam();
		if (key){
			params = [this.buildApiKeyParam(), this.buildUrlParams()].join(',');
		} else {
			params = [this.buildUrlParams()].join(',');
		}
		if (params){
			url = [path, params].join('?'); 
		} else url = path;
		return url;
	}
	buildApiKeyParam(){
		var apiKeyParam;
		var key = this.getApiKey();
		if (key){
			apiKeyParam = `key:${key}`;
		}
		return apiKeyParam;
	}
	
	buildUrlPath(){
		var url;
		var { protocol, domain, path } = this.getApiConfig();
		url = [apiConfig.protocol, apiConfig.domain, this.getEndpoint()].join('/');
		return url;
	}
	
	buildUrlParams(){
        var paramObj, strParams,urlParams;
		paramObj = this.getParams();
        Object.keys(paramObj).forEach(function(param){
            if (paramObj[param]) { 
				strParams = param + '=' + paramObj[param];
				if (!urlParams) urlParams = strParams;
				else urlParams = [urlParams, strParams ].join('&');
			}
        });
        return urlParams;
    }
	getUrl(){
		return this.buildUrl();
	}
}




var apiConfig = {
	protocol : 'https:/',
	domain: 'api-adresse.data.gouv.fr',
	path: ''
}
var urlBuilder = new UrlBuilder(apiConfig);
urlBuilder.setEndpoint('search');
urlBuilder.setParams({q:'Avenue+André+Reinson+Bordeaux'});
var url = urlBuilder.getUrl();
console.log(url);